/**
 * Partner hosts
 *
 * Some share links are handed out on a partner's own domain rather than files.cinesend.com
 * (see DCP_MAGIC_FILMFREEWAY_SHARE_DOMAIN on the API). The page is the same, but the CineSend
 * chrome is not wanted there.
 *
 * 		import getPartner from '@helpers/partner'
 *
 * 		if (getPartner()) {
 * 			// Serving a partner's domain
 * 		}
 */

const FILM_FREEWAY = {
  name: "FilmFreeway",
  // Matches the filmfreeway theme in dcp-magic-client (src/styles/index.css)
  font: "'Open Sans', ui-sans-serif, system-ui, sans-serif",
  color: "#21212d"
}

const PARTNERS = {
  "dcp.filmfreeway.com": FILM_FREEWAY,
  // valet proxy local-dcp.filmfreeway.com.test http://localhost:8001 --secure
  "local-dcp.filmfreeway.com.test": FILM_FREEWAY
}

const getPartner = () => PARTNERS[window.location.hostname] ?? null

export default getPartner
